export const messages = {
    "wr-dashboard.search.input.hint": "Cerca",
    "wr-dashboard.search.label.breadcrumb": "Risultati della ricerca",
    "wr-dashboard.search.message.empty": "Nessun elemento corrispondente alla ricerca",
    "wr-dashboard.side-bar.selected.title:plural": "{count} elementi selezionati | {count} elemento selezionato | {count} elementi selezionati",
    "wr-dashboard.side-bar.backup-type.disk": "Disco",
    "wr-dashboard.side-bar.backup-type.file": "File",
    "wr-dashboard.side-bar.backup-type.notarized": "File e cartelle autenticate",
    "wr-dashboard.side-bar.backup-type.exchange": "Applicazione - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Applicazione - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Applicazione - Stato del sistema",
    "wr-dashboard.side-bar.backup-type.application": "Applicazione",
    "wr-dashboard.backups-table.column.name": "Nome",
    "wr-dashboard.backups-table.column.size": "Dimensioni",
    "wr-dashboard.backups-table.column.version": "Ultima versione",
    "wr-dashboard.backups-table.action.delete": "Elimina",
    "wr-dashboard.backups-table.message.no-backups": "Non sono ancora stati creati backup nel cloud",
    "wr-dashboard.backups-sidebar.label.size": "Dimensioni",
    "wr-dashboard.backups-sidebar.label.type": "Tipo",
    "wr-dashboard.backups-sidebar.label.version": "Ultima versione",
    "wr-dashboard.backups-sidebar.label.created": "Creazione",
    "wr-dashboard.backups-sidebar.label.machine": "Macchina",
    "wr-dashboard.backups-sidebar.label.owner": "Proprietario",
    "wr-dashboard.content-table.column.name": "Nome",
    "wr-dashboard.content-table.column.versions": "Versioni",
    "wr-dashboard.content-table.column.volumes": "Volumi",
    "wr-dashboard.content-table.column.path": "Percorso",
    "wr-dashboard.content-table.column.size": "Dimensioni",
    "wr-dashboard.content-table.column.version": "Ultima versione",
    "wr-dashboard.content-table.action.notary-verify": "Verifica",
    "wr-dashboard.content-table.action.notary-get-crt": "Ottieni certificato",
    "wr-dashboard.content-table.action.asign": "Invia per la firma",
    "wr-dashboard.content-table.action.versions": "Versioni",
    "wr-dashboard.content-table.action.restore": "Scarica",
    "wr-dashboard.content-table.label.size": "Dimensioni",
    "wr-dashboard.content-table.label.created": "Creazione",
    "wr-dashboard.content-table.label.modified": "Modificato",
    "wr-dashboard.content-table.message.empty-folder": "Questa cartella è vuota",
    "wr-dashboard.password-dialog-box.title.backup": "Backup crittografato",
    "wr-dashboard.password-dialog-box.title.archive": "Archivio crittografato",
    "wr-dashboard.password-dialog-box.message.backup": "Specificare la password per accedere al backup {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Specificare la password per accedere all'archivio {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Password",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Password non corretta",
    "wr-dashboard.form.button.open": "Apri",
    "wr-dashboard.form.button.close": "Chiudi",
    "wr-dashboard.form.button.cancel": "Annulla",
    "wr-dashboard.form.button.continue": "Continua",
    "wr-dashboard.form.button.proceed": "Procedi",
    "wr-dashboard.form.button.delete": "Elimina",
    "wr-dashboard.form.button.done": "Fine",
    "wr-dashboard.form.button.retry": "Riprova",
    "wr-dashboard.notary.verify.view.status.downloading": "Download in corso...",
    "wr-dashboard.notary.verify.view.status.validating": "Convalida in corso...",
    "wr-dashboard.notary.verify.view.status.pending": "Certificato in sospeso...",
    "wr-dashboard.notary.verify.view.status.fail": "Mancata corrispondenza del certificato...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Ottieni certificato",
    "wr-dashboard.notary.verify.view.file-info.name": "NOME",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "APPROVATO DA",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "DATA DI BACKUP",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "DATA DI AUTENTICAZIONE",
    "wr-dashboard.notary.verify.view.button.cancel": "Annulla",
    "wr-dashboard.notary.verify.view.button.done": "Fine",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Versione browser non supportata",
    "wr-dashboard.versions-dialog-box.title": "Versioni di {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Invia per la firma",
    "wr-dashboard.asign-dialog-box.message": "La versione del file è condivisa ma nessuno può visualizzare il file se non dispone del collegamento.Passare ad ASign per aggiungere i firmatari e condividere il collegamento.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Mostra dettagli file",
    "wr-dashboard.page-not-found.title": "Pagina non trovata",
    "wr-dashboard.page-not-found.message.main": "Impossibile trovare la pagina che si stava cercando.",
    "wr-dashboard.page-not-found.message.description": "Il collegamento potrebbe essere scaduto oppure l'indirizzo non è stato digitato correttamente.",
    "wr-dashboard.page-not-found.message.error": "Codice errore: 404",
    "wr-dashboard.server-error.title": "Server non disponibile",
    "wr-dashboard.server-error.message": "Il server al momento non è disponibile. Riprovare in un secondo momento.",
    "wr-dashboard.server-error.message.error": "Codice errore: 500",
    "wr-dashboard.account-menu.action.sign-out": "Esci",
    "wr-dashboard.breadcrumb.item.machines": "Sistemi",
    "wr-dashboard.breadcrumb.item.failed-backups": "Backup non riusciti",
    "wr-dashboard.machines-table.column.name": "Nome",
    "wr-dashboard.machines-table.column.size": "Dimensioni",
    "wr-dashboard.machines-table.message.no-machines": "Non sono ancora presenti sistemi nel cloud",
    "wr-dashboard.incomplete-backups.message.status:plural": "Sono presenti {count} backup incompleti o non riusciti che occupano {size} di storage | È presente {count} backup incompleto o non riuscito che occupa {size} di storage | Sono presenti {count} backup incompleti o non riusciti che occupano {size} di storage",
    "wr-dashboard.incomplete-backups.button.view": "Visualizza backup",
    "wr-dashboard.incomplete-backups.button.delete": "Elimina backup",
    "wr-dashboard.machines-table.message.space-used:plural": "Utilizzo totale backup {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Elimina archivi",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Elimina archivi incompleti",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Elimina tutti gli archivi incompleti",
    "wr-dashboard.delete-archive.message": "Eliminare permanentemente gli archivi selezionati da tutte le posizioni? Tutti i dati verranno eliminati e non sarà possibile ripristinarli.",
    "wr-dashboard.delete-archive.deletion-warning-message": "Le modifiche effettuate nella console web di ripristino potrebbero non essere visibili nel corrispettivo workload della console di protezione se quel workload non è online o se nessun agente è online per applicare le modifiche",
    "wr-dashboard.delete-archive.locked-error-message": "L'archivio è stato bloccato per garantire la coerenza dei dati. Portare a termine tutte le operazioni da eseguire con l'archivio (ad esempio Sfoglia, Ripristina, Esegui backup) e riprovare.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Certificato sospeso",
    "wr-dashboard.certificate-pending-dialog-box.message": "Riprovare tra qualche minuto.",
    "wr-dashboard.form.button.ok": "OK"
};
